export const COMPANY_INFO_LOAD = 'COMPANY_INFO_LOAD';
export const COMPANY_INFO_LOADED = 'COMPANY_INFO_LOADED';
export const COMPANY_INFO_ERROR = 'COMPANY_INFO_ERROR';
